module.exports = __webpack_public_path__ + "img/jpg.5ffbc9bc.svg";